import {GridLoader} from "react-spinners";
import {Stack} from "@mui/material";

export default function SuspenseLoader() {
    return (<Stack sx={{
        justifyContent : 'center',
        alignItems: 'center',
        flex: 1,
        height: '100%',
        minHeight:'100vh'
    }}>
        <GridLoader color="#29AF88" />
    </Stack>);
}
